// カートに保存済みの味リストは旧表記のまま残るため、旧名を現在の名前に読み替える
const LEGACY_FLAVOR_NAMES = {
  '小倉': 'あずき'
};

class FlavorSelector {
  constructor() {
    this.modal = null;
    this.currentItemKey = null;
    this.currentItemData = null;
    this.flavors = [
      {
        id: 'ogura',
        name: 'あずき',
        description: '甘さ控えめなあずき風味',
        image: 'https://cdn.shopify.com/s/files/1/0613/5880/0957/files/02_9094064a-be19-444d-bc0a-a1e901e65ceb.jpg?v=1744011821'
      },
      {
        id: 'sesame',
        name: 'ごま',
        description: '香ばしいごま風味',
        image: 'https://cdn.shopify.com/s/files/1/0613/5880/0957/files/02_a1efe0f6-1cda-41b1-b99f-9c210ce389e5.jpg?v=1744011862'
      },
      {
        id: 'sendai_miso',
        name: '仙台みそ',
        description: '深い味わいの仙台みそ風味',
        image: 'https://cdn.shopify.com/s/files/1/0613/5880/0957/files/02_79a202ec-07cf-40bf-be5a-8393ffd119e9.jpg?v=1744011876'
      },
      {
        id: 'matcha',
        name: '抹茶',
        description: '上品な抹茶風味',
        image: 'https://cdn.shopify.com/s/files/1/0613/5880/0957/files/02_1d69da4f-d468-4e6f-8ec2-e15c7896e748.jpg?v=1744011849'
      },
      {
        id: 'aonori',
        name: '青のり',
        description: '風味豊かな青のり風味',
        image: 'https://cdn.shopify.com/s/files/1/0613/5880/0957/files/02_18d6510a-d7a5-4853-bfac-1cc37f6cdbbe.jpg?v=1744011891'
      },
      {
        id: 'coffee',
        name: 'コーヒー',
        description: '香り高いコーヒー風味',
        image: 'https://cdn.shopify.com/s/files/1/0613/5880/0957/files/02_d83b69d6-2217-4691-8498-311a3c341251.jpg?v=1744011807'
      },
      {
        id: 'wine',
        name: 'ワイン',
        description: '上品なワイン風味',
        image: 'https://cdn.shopify.com/s/files/1/0613/5880/0957/files/02_3dc0976c-7f93-4a52-97c5-b7a40ac31ebd.jpg?v=1744011836'
      }
    ];
    this.selectedFlavors = {};
    this.init();
  }

  init() {
    this.createModal();
    this.bindEvents();
  }

  createModal() {
    const modalHTML = `
      <div id="flavor-modal" class="flavor-modal">
        <div class="flavor-modal__content">
          <button class="flavor-modal__close" type="button">&times;</button>
          <h3 class="flavor-modal__title">
            味を選択してください（<span id="total-pieces">0</span>個）
            <span class="flavor-modal__counter" id="selection-counter">0/0</span>
          </h3>
          <div class="flavor-selector" id="flavor-selector">
            <!-- 味選択項目がここに動的に追加される -->
          </div>
          <div class="flavor-modal__summary" id="flavor-summary">
            <h4>選択中の味</h4>
            <div id="summary-list">
              <!-- 選択中の味一覧がここに表示される -->
            </div>
          </div>
          <div class="flavor-modal__error" id="flavor-error">
            <!-- エラーメッセージがここに表示される -->
          </div>
          <div class="flavor-modal__actions">
            <button type="button" class="button button--secondary" id="cancel-selection">
              キャンセル
            </button>
            <button type="button" class="button button--primary" id="save-selection">
              選択完了
            </button>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('flavor-modal');
  }

  bindEvents() {
    // モーダル関連のイベント
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-flavor-selector]')) {
        e.preventDefault();
        this.openModal(e.target);
      }
    });

    // モーダル内のイベント
    this.modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('flavor-modal') ||
        e.target.classList.contains('flavor-modal__close') ||
        e.target.id === 'cancel-selection') {
        this.closeModal();
      }

      if (e.target.id === 'save-selection') {
        this.saveSelection();
      }

      // quantity-btnボタンまたはその子要素がクリックされた場合
      const quantityBtn = e.target.closest('.quantity-btn');
      if (quantityBtn) {
        e.preventDefault();
        this.handleQuantityChange(quantityBtn);
      }
    });

    // 数量入力のイベント
    this.modal.addEventListener('input', (e) => {
      if (e.target.classList.contains('quantity-input')) {
        this.handleQuantityInput(e.target);
      }
    });

    // ESCキーでモーダルを閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });
  }

  openModal(button) {
    this.currentItemKey = button.dataset.itemKey;
    this.currentItemData = {
      itemKey: button.dataset.itemKey,
      totalPieces: parseInt(button.dataset.totalPieces),
      currentFlavors: this.parseStoredFlavors(button.dataset.currentFlavors)
    };

    // 既存の選択がない場合はデフォルト値を設定
    if (Object.keys(this.currentItemData.currentFlavors).length === 0) {
      this.selectedFlavors = this.getDefaultQuantities(this.currentItemData.totalPieces);
    } else {
      this.selectedFlavors = { ...this.currentItemData.currentFlavors };
    }

    this.renderFlavorSelector();
    this.updateSummary();
    this.updateQuantityButtons();
    this.updateCounter();
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    // フォーカス管理
    this.modal.querySelector('.flavor-modal__close').focus();
  }

  closeModal() {
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
    this.hideError();
  }

  renderFlavorSelector() {
    const container = document.getElementById('flavor-selector');
    const totalPiecesSpan = document.getElementById('total-pieces');

    totalPiecesSpan.textContent = this.currentItemData.totalPieces;

    container.innerHTML = this.flavors.map(flavor => {
      const currentQty = this.selectedFlavors[flavor.id] || 0;
      return `
        <div class="flavor-item" data-flavor-id="${flavor.id}">
          <img src="${flavor.image}" alt="${flavor.name}" class="flavor-item__image">
          <div class="flavor-item__content">
            <h4 class="flavor-item__name">${flavor.name}</h4>
            <div class="quantity-control">
              <button type="button" class="quantity-btn" data-action="decrease" data-flavor-id="${flavor.id}">
                −
              </button>
              <input type="number" class="quantity-input" 
                     data-flavor-id="${flavor.id}" 
                     value="${currentQty}" 
                     min="0" 
                     max="${this.currentItemData.totalPieces}">
              <button type="button" class="quantity-btn" data-action="increase" data-flavor-id="${flavor.id}">
                ＋
              </button>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  handleQuantityChange(button) {
    console.log('ボタンクリック検出:', {
      action: button.dataset.action,
      flavorId: button.dataset.flavorId,
      button: button
    });

    const flavorId = button.dataset.flavorId;
    const action = button.dataset.action;

    if (!flavorId || !action) {
      console.error('データ属性が見つかりません:', button);
      return;
    }

    const input = this.modal.querySelector(`input[data-flavor-id="${flavorId}"]`);
    if (!input) {
      console.error('入力フィールドが見つかりません:', flavorId);
      return;
    }

    let currentValue = parseInt(input.value) || 0;
    console.log('現在の値:', currentValue);

    if (action === 'increase') {
      const newValue = Math.min(currentValue + 1, this.currentItemData.totalPieces);
      console.log('増加:', currentValue, '->', newValue);
      currentValue = newValue;
    } else if (action === 'decrease') {
      const newValue = Math.max(currentValue - 1, 0);
      console.log('減少:', currentValue, '->', newValue);
      currentValue = newValue;
    }

    input.value = currentValue;

    if (currentValue === 0) {
      delete this.selectedFlavors[flavorId];
    } else {
      this.selectedFlavors[flavorId] = currentValue;
    }

    console.log('選択された味:', this.selectedFlavors);

    this.updateSummary();
    this.updateQuantityButtons();
    this.updateCounter();
  }

  handleQuantityInput(input) {
    const flavorId = input.dataset.flavorId;
    let value = parseInt(input.value) || 0;

    value = Math.max(0, Math.min(value, this.currentItemData.totalPieces));
    input.value = value;

    if (value === 0) {
      delete this.selectedFlavors[flavorId];
    } else {
      this.selectedFlavors[flavorId] = value;
    }

    this.updateSummary();
    this.updateQuantityButtons();
    this.updateCounter();
  }

  updateCounter() {
    const totalSelected = Object.values(this.selectedFlavors).reduce((sum, qty) => sum + qty, 0);
    const counter = document.getElementById('selection-counter');
    if (counter) {
      counter.textContent = `${totalSelected}/${this.currentItemData.totalPieces}`;
    }
  }

  updateQuantityButtons() {
    const totalSelected = Object.values(this.selectedFlavors).reduce((sum, qty) => sum + qty, 0);

    this.flavors.forEach(flavor => {
      const currentQty = this.selectedFlavors[flavor.id] || 0;
      const increaseBtn = this.modal.querySelector(`[data-action="increase"][data-flavor-id="${flavor.id}"]`);
      const decreaseBtn = this.modal.querySelector(`[data-action="decrease"][data-flavor-id="${flavor.id}"]`);

      if (increaseBtn && decreaseBtn) {
        // 増加ボタン: 総数が上限に達している場合は無効
        increaseBtn.disabled = totalSelected >= this.currentItemData.totalPieces;

        // 減少ボタン: 現在の数量が0の場合は無効
        decreaseBtn.disabled = currentQty === 0;
      }
    });
  }

  updateSummary() {
    const summaryList = document.getElementById('summary-list');
    const selectedFlavorEntries = Object.entries(this.selectedFlavors).filter(([_, qty]) => qty > 0);

    if (selectedFlavorEntries.length === 0) {
      summaryList.innerHTML = '<p style="color: rgb(var(--color-foreground-75)); font-style: italic;">まだ選択されていません</p>';
      return;
    }

    const totalSelected = selectedFlavorEntries.reduce((sum, [_, qty]) => sum + qty, 0);

    summaryList.innerHTML = `
      ${selectedFlavorEntries.map(([flavorId, qty]) => {
      const flavor = this.flavors.find(f => f.id === flavorId);
      return `
          <div class="summary-item">
            <span>${flavor.name}</span>
            <span>${qty}個</span>
          </div>
        `;
    }).join('')}
      <div class="summary-item">
        <span>合計</span>
        <span>${totalSelected}個 / ${this.currentItemData.totalPieces}個</span>
      </div>
    `;
  }

  saveSelection() {
    const totalSelected = Object.values(this.selectedFlavors).reduce((sum, qty) => sum + qty, 0);

    if (totalSelected !== this.currentItemData.totalPieces) {
      this.showError(`${this.currentItemData.totalPieces}個すべてを選択してください。現在${totalSelected}個選択中です。`);
      return;
    }

    this.updateCartWithFlavors();
  }

  async updateCartWithFlavors() {
    try {
      // カート属性として味選択情報を保存
      const flavorData = Object.entries(this.selectedFlavors)
        .filter(([_, qty]) => qty > 0)
        .map(([flavorId, qty]) => {
          const flavor = this.flavors.find(f => f.id === flavorId);
          return `${flavor.name}:${qty}個`;
        })
        .join(',');

      const body = JSON.stringify({
        attributes: {
          [`flavor_selection_${this.currentItemKey}`]: flavorData
        }
      });

      const response = await fetch(`${window.routes ? routes.cart_update_url : '/cart/update.js'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });

      if (!response.ok) {
        throw new Error('カートの更新に失敗しました');
      }

      // 成功時の処理
      this.closeModal();
      this.updateCartDisplay();

      // カート更新イベントを発火（利用可能な場合）
      if (window.publish && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'flavor-selector',
          cartData: await response.json()
        });
      } else {
        // フォールバック: ページをリロードしてカート表示を更新
        window.location.reload();
      }

    } catch (error) {
      console.error('味選択の保存エラー:', error);
      this.showError('味選択の保存に失敗しました。もう一度お試しください。');
    }
  }

  updateCartDisplay() {
    // カート画面の表示を更新
    const button = document.querySelector(`[data-item-key="${this.currentItemKey}"]`);
    if (button) {
      const container = button.closest('.cart-item').querySelector('.cart-item__selected-flavors');
      if (container) {
        this.renderSelectedFlavors(container);
      }
    }
  }

  renderSelectedFlavors(container) {
    const selectedFlavorEntries = Object.entries(this.selectedFlavors).filter(([_, qty]) => qty > 0);

    if (selectedFlavorEntries.length === 0) {
      container.innerHTML = '<p>味が選択されていません</p>';
      return;
    }

    const flavorList = selectedFlavorEntries.map(([flavorId, qty]) => {
      const flavor = this.flavors.find(f => f.id === flavorId);
      return `<li><span>${flavor.name}</span><span>${qty}個</span></li>`;
    }).join('');

    container.innerHTML = `
      <p>選択中の味:</p>
      <ul class="cart-item__selected-flavors-list">
        ${flavorList}
      </ul>
    `;
  }

  parseStoredFlavors(flavorString) {
    if (!flavorString) return {};

    const flavors = {};
    flavorString.split(',').forEach(item => {
      const match = item.match(/^(.+):(\d+)個$/);
      if (match) {
        const flavorName = LEGACY_FLAVOR_NAMES[match[1]] || match[1];
        const qty = parseInt(match[2]);
        const flavor = this.flavors.find(f => f.name === flavorName);
        if (flavor) {
          flavors[flavor.id] = qty;
        }
      }
    });

    return flavors;
  }

  showError(message) {
    const errorElement = document.getElementById('flavor-error');
    errorElement.textContent = message;
    errorElement.classList.add('active');
  }

  hideError() {
    const errorElement = document.getElementById('flavor-error');
    errorElement.classList.remove('active');
  }

  getDefaultQuantities(totalPieces) {
    const defaults = {};

    // 味の順序: あずき、ごま、仙台みそ、抹茶、青のり、コーヒー、ワイン
    const flavorIds = ['ogura', 'sesame', 'sendai_miso', 'matcha', 'aonori', 'coffee', 'wine'];

    switch (totalPieces) {
      case 5:
        // 5個入り：1, 1, 1, 1, 1, 0, 0
        const quantities5 = [1, 1, 1, 1, 1, 0, 0];
        flavorIds.forEach((id, index) => {
          defaults[id] = quantities5[index];
        });
        break;

      case 7:
        // 7個入り：1つずつ
        flavorIds.forEach(id => {
          defaults[id] = 1;
        });
        break;

      case 10:
        // 10個入り：2, 2, 2, 1, 1, 1, 1
        const quantities10 = [2, 2, 2, 1, 1, 1, 1];
        flavorIds.forEach((id, index) => {
          defaults[id] = quantities10[index];
        });
        break;

      case 14:
        // 14個入り：2つずつ
        const quantities14 = [2, 2, 2, 2, 2, 2, 2];
        flavorIds.forEach((id, index) => {
          defaults[id] = quantities14[index];
        });
        break;

      default:
        // その他の場合は全て0
        flavorIds.forEach(id => {
          defaults[id] = 0;
        });
        break;
    }

    return defaults;
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  new FlavorSelector();
});

// カスタムエレメントとして定義
if (!customElements.get('flavor-selector')) {
  customElements.define('flavor-selector', class extends HTMLElement {
    connectedCallback() {
      if (!window.flavorSelector) {
        window.flavorSelector = new FlavorSelector();
      }
    }
  });
} 